module.exports = __webpack_public_path__ + "img/santa_monica_stickers_hor.28e34997.png";